/**
 * Neon multi-select chip DOM ids flow into `querySelector(\`#${id}\`)` without `CSS.escape`.
 * Course ids like `ALG001.7` would be parsed as id `ALG001` + class `7`, breaking chips/selection.
 * `option.name` stays the raw course id for `modelValue`; only `option.id` is sanitized.
 */
export function toNeonSafeCourseOptionDomId(optionIdPrefix: string, courseId: string): string {
  const safeCourseId = courseId.replace(/\./g, '__dot__');
  return `${optionIdPrefix}-${safeCourseId}`;
}
